<template>
  <section class="file-info-panel">
    <header class="header">
      <h3>{{ file.name }}</h3>
      <close-button @click="$modal.hideAll()"></close-button>
    </header>
    <main class="main">
      <dl>
        <dt>Naam</dt>
        <dd>{{ file.name }}</dd>
        <dt>Bron</dt>
        <dd>{{ file.archive }}</dd>
        <dt>Verwijderd op</dt>
        <dd>{{ $filters.formatDate(file.deleted) }} om {{ $filters.formatTime(file.deleted) }}</dd>
        <dt>Verwijderd door</dt>
        <dd>{{ file.deletedBy }}</dd>
      </dl>
    </main>
  </section>
</template>

<script>

export default {
  name: 'TrashInfo',
  props: ['file']
}
</script>

<style lang="scss" scoped>
.file-info-panel {
  padding: 25px;

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    h3 {
      font-size: 15px;
      font-weight: 500;
      color: var(--sub-color);
    }
  }

  .main {
    dl {
      display: flex;
      flex-flow: row wrap;
      line-height: 28px;
      dt {
        flex-basis: 30%;
      }
      dd {
        flex-basis: 70%;
      }
    }
  }
}
</style>
